import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css } from 'styled-components';

const filterBreakpoint = 'max-width: 767px';

export const Container = styled.div<{ disabled?: boolean }>`
  position: relative;
  flex: 1;
  ${(props) => (props.disabled ? 'opacity: 0.5;' : '')}
`;

export const AtlLabel = styled.label`
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.textDark};
  white-space: nowrap;

  b {
    font-weight: 600;
  }

  @media (${mobileXXLargeMax}) {
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export const InputLabel = styled.label`
  display: block;
  color: ${(props) => props.theme.textDark};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-left: ${platform.select(18, 0)}px;
`;

export const NativeSelect = styled.select`
  pointer-events: none;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media (${filterBreakpoint}) {
    pointer-events: auto;
  }

  // Ensure native select is also used on large iPads
  @supports (-webkit-touch-callout: none) {
    pointer-events: auto;
  }
`;

export const OptionList = styled.div<{
  active: boolean;
  disableMaxHeight?: boolean;
  alignTop?: boolean;
}>`
  display: none;
  position: absolute;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background-color: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.keyline};
  padding: 10px 0;
  z-index: 90;

  ${() =>
    platform.type === 'propertypal'
      ? `
    margin: 4px 0 0;
  border-radius: 30px;
  `
      : `
      margin: -1px 0 0;
  `}

  ${(props) =>
    props.active &&
    `
    display: block;
  `}

  ${(props) =>
    props.disableMaxHeight &&
    `
    max-height: calc(100vh - 150px);
  `}

  ${(props) =>
    props.alignTop
      ? css`
          bottom: 100%;
          margin-bottom: -1px;
          margin-top: 0px;
        `
      : ''}
`;

export const OptionItem = styled.button<{ active: boolean; isGroup?: boolean }>`
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 15px;
  font-size: 16px;
  color: ${(props) => props.theme.textDark};
  font-weight: ${(props) => (props.active ? '600' : '400')};

  &:hover {
    background-color: ${(props) => props.theme.backgroundLightest};
  }

  &[data-active='true'] {
    background: ${({ theme }) => theme.backgroundLightest};
  }

  ${(props) =>
    props.isGroup &&
    `
    background: ${props.theme.backgroundLighter};
    color: ${props.theme.textLight};
    font-weight: 600;
  `}
`;
